import React, { useEffect, useState } from "react";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { getMonthName } from "../../../../utils/getMonthName";
import { fixedPercentage } from "../../../../utils/common";
import { useUser } from "../../../../context/AuthContext";

function View(props) {
  const { user } = useUser();
  const viewData = props.data || {};
  const energyTypesForUse = Array.isArray(viewData?.energyTypeRequiredForUse)
    ? viewData.energyTypeRequiredForUse
    : viewData?.energyTypeRequiredForUse
      ? [viewData.energyTypeRequiredForUse]
      : Array.isArray(viewData?.fuelEntries)
        ? viewData.fuelEntries.map((entry) => entry?.fuelName).filter(Boolean)
        : [];
  const fuelEntriesForView = Array.isArray(viewData?.fuelEntries)
    ? viewData.fuelEntries
    : [];
  const fuelMaintenanceText =
    fuelEntriesForView.length > 0
      ? fuelEntriesForView
          .map((entry) =>
            [entry?.fuelName, entry?.quantity, entry?.unit]
              .filter(Boolean)
              .join(" - "),
          )
          .join(", ")
      : [
          viewData?.energyOrFuelUsedForMaintenance,
          viewData?.energyOrFuelUsedForMaintenanceUnit,
        ]
          .filter(Boolean)
          .join(" ");

  const formatSoldUnitForView = () => {
    const qtyRaw =
      viewData?.soldUnitQuantity ??
      viewData?.soldUnit?.quantity ??
      viewData?.soldUnitValue;
    const qtyStr =
      qtyRaw !== undefined && qtyRaw !== null && String(qtyRaw).trim() !== ""
        ? String(qtyRaw).trim()
        : "";
    const su = viewData?.soldUnit;
    let unitStr = "";
    if (su != null && typeof su === "object") {
      unitStr = String(su.unit ?? "").trim();
    } else if (su != null && su !== "") {
      unitStr = String(su).trim();
    } else {
      unitStr = String(
        viewData?.soldUnitType ?? viewData?.soldUnitUnit ?? "",
      ).trim();
    }
    if (qtyStr && unitStr) return `${qtyStr} ${unitStr}`;
    if (qtyStr) return qtyStr;
    if (unitStr) return unitStr;
    return "";
  };

  const [processTotals, setProcessTotals] = useState({});

  // Calculate total quantity for each process
  const calculateProcessTotals = () => {
    const totals = {};

    props.data?.processes?.forEach((segment) => {
      let total = 0;
      segment?.emissions?.forEach((emission) => {
        const quantity = Number(emission?.quantity) || 0;
        total += quantity;
      });
      totals[segment.processName] = total;
    });

    setProcessTotals(totals);
  };

  useEffect(() => {
    calculateProcessTotals();
    console.log(props.data, "for the view pages");
  }, [props.data]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "40.5rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {/* ... (previous Box and IconButton code remains the same) ... */}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "2%",
        }}
      >
        <IconButton
          onClick={() => props.setView(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          pr: 1,
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        {/* ... (previous Typography and form fields remain the same) ... */}
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Product Master Details
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Date
            </Typography>

            <p>
              {new Date(
                props.data?.date || props.data?.createdAt,
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }) ?? ""}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Total Emission
            </Typography>
            <p>{props.data?.totalEmission ?? ""}</p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Product Name
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.data?.productName ?? ""}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Product ID
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.data?.productId ?? ""}
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Product Category
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {viewData?.category || viewData?.productCategory || ""}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Product Description
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {viewData?.description || viewData?.productDescription || ""}
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Average weight per unit of product
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {viewData?.weight ?? viewData?.averageWeightPerUnit ?? ""}{" "}
              {viewData?.weightUnit || viewData?.averageWeightPerUnitUnit || ""}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Frequency of Maintenance per year
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {viewData?.frequency ??
                viewData?.frequencyOfMaintenancePerYear ??
                ""}
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Energy or Fuel Used for Maintenance
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {fuelMaintenanceText}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Disposal Method
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.data?.disposalMethod ?? ""}
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Expected Lifetime of the Product (years)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {viewData?.lifetime ??
                viewData?.expectedLifetimeOfTheProductYears ??
                ""}
            </p>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Sold unit
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {formatSoldUnitForView() || ""}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Energy type required for use
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {energyTypesForUse.join(", ")}
            </p>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Manufacturing process
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.data?.skipManufacturingProcess === true ? "true" : "false"}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Manufacturing Skip reason
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.data?.skipManufacturingProcessReason ?? "-"}
            </p>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", flex: 1 }}>
          Sample Used for Testing
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", flex: 1 }}
            >
              Sample Basis
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {props.data?.sampleBasis ?? "-"}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", flex: 1 }}
            >
              Sample Quantity
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {props.data?.sampleQuantity ?? "-"}
            </p>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", flex: 1 }}
            >
              Unit
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {props.data?.unit ?? "-"}
            </p>
          </Box>
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", flex: 1, mt: "1rem" }}
          >
            Emission Release in Processes
          </Typography>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              mt: "1rem",
              borderRadius: "10px",
            }}
          >
            <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
              <TableHead>
                <TableRow
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#1C486B",
                    border: "1px solid #ddd",
                  }}
                >
                  {props?.inputData?.map((section, tableIndex) => (
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "auto",
                      }}
                    >
                      {section?.title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.processes.length > 0 &&
                  props?.data?.processes?.map((segment, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      {segment?.emissions.map((item, emissionIndex) => (
                        <TableRow key={`${rowIndex}-${emissionIndex}`}>
                          {emissionIndex === 0 && (
                            <TableCell
                              sx={{
                                border: "1px solid #DBDBDB",
                                py: "0.5rem",
                                width: "8rem",
                                maxWidth: "8rem",
                                fontSize: "14px",
                                fontWeight: 500,
                                fontFamily: "inter",
                              }}
                              rowSpan={(segment?.emissions?.length || 0) + 1}
                            >
                              {segment?.processName}
                            </TableCell>
                          )}
                          <TableCell
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: "8rem",
                              maxWidth: "8rem",
                              background: "white",
                              fontSize: "14px",
                              fontWeight: 500,
                              fontFamily: "inter",
                            }}
                          >
                            {/* {item.emissionsName} */}
                            {item.emissionsName[
                              rowIndex
                            ]?.item?.emissionsName?.includes(";")
                              ? item.emissionsName[
                                  rowIndex
                                ].item.emissionsName.split(";")[1]
                              : item.emissionsName[rowIndex]?.item
                                  ?.emissionsName ||
                                (item?.emissionsName?.includes(";")
                                  ? item?.emissionsName.split(";")[1]
                                  : item?.emissionsName)}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: "5rem",
                              maxWidth: "5rem",
                              background: "white",
                              fontSize: "14px",
                              fontWeight: 500,
                              fontFamily: "inter",
                            }}
                          >
                            {item.quantity}
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: "5rem",
                              maxWidth: "5rem",
                              background: "white",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontSize: "14px",
                              fontWeight: 500,
                              fontFamily: "inter",
                            }}
                          >
                            {item.unit}
                          </TableCell>
                        </TableRow>
                      ))}
                      {/* Process Total Row */}
                      <TableRow
                        sx={{
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                        }}
                      >
                        <TableCell
                          colSpan={1}
                          sx={{
                            border: "1px solid #DBDBDB",
                            textAlign: "left",
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "inter",
                          }}
                        >
                          {/* {segment.processName} Total */}
                          Total
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #DBDBDB",
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "inter",
                          }}
                        >
                          {fixedPercentage(processTotals[segment.processName])}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid #DBDBDB",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "inter",
                          }}
                        >
                          {segment?.emissions?.[0]?.unit || ""}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {!user?.companyAdmin && (
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%",
              }}
              onClick={() => props.handleEdit()}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.view}
        onClose={() => props.setView(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default View;

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
  "& .MuiSelect-select": {
    height: "56px",
    display: "flex",
    alignItems: "center",
  },
}));
